import React, { Component } from 'react';
import { Modal, Steps, Button, message, Select } from 'antd';
const Step = Steps.Step;
const Option = Select.Option;

class VisitorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {step: 0, stepLimit: 0, validation: false, visitor: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handleName = this.handleName.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handleCompany = this.handleCompany.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.state.validation)
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.visitor);
      this.setState({validation: true, visitor: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  handleName(event) {
    this.setProp('name', event.target.value);
    this.setState({validation: true});
  }

  handleEmail(event) {
    this.setProp('email', event.target.value);
    this.setState({validation: true});
  }

  handleCompany(value) {
    this.setProp('visit_company_id', value);
    this.setState({validation: true});
  }

  setProp(prop, value) {
    const record = this.state.visitor;
    record[prop] = value;

    this.setState({visitor: record});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Options for company select
    const companyOptions = this.props.companies.map(company => {
      return (
        <Option value={company.id} className="text-capitalize" key={company.id}>{company.name}</Option>
      );
    });

    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Nombre" />
            <Step title="Finalizar" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Nombre</label>
              <input type="text" className="form-control" defaultValue={this.props.current.name} placeholder="Nombre de visitante" onChange={this.handleName} />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input type="text" className="form-control" defaultValue={this.props.current.email} placeholder="Email de visitante" onChange={this.handleEmail} />
            </div>

            <div className="form-group">
              <label>Empresa visitante</label>
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Elige una empresa"
                optionFilterProp="children"
                onChange={this.handleCompany}
                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              >
                {companyOptions}
              </Select>
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default VisitorModal;



// WEBPACK FOOTER //
// ./src/components/modals/VisitorModal.js